document.addEventListener("DOMContentLoaded", () => {

  const button = document.getElementById("request-order");

  if (!button) return;

  button.addEventListener("click", async () => {

    const nombre = document.getElementById("customer_name")?.value.trim();
    const telefono = document.getElementById("customer_phone")?.value.trim();

    if (!nombre) {
      alert("Ingresa tu nombre.");
      return;
    }

    if (!telefono) {
      alert("Ingresa tu teléfono.");
      return;
    }

    button.disabled = true;
    button.innerText = "Enviando...";

    try {

      // Obtener carrito
      const cart = await fetch("/cart.js").then(r => r.json());

      // Preparar productos
      const items = cart.items.map(item => {

        const properties = [];

        if (item.properties) {
          Object.entries(item.properties).forEach(([name, value]) => {
            if (value) {
              properties.push({
                name,
                value
              });
            }
          });
        }
        console.log(item.properties);
        
        return {
          variant_id: item.variant_id,
          quantity: item.quantity,
          properties
        };

      });

      console.log("ITEMS ENVIADOS:", items);

      // Enviar al Worker
      const response = await fetch(
        "https://gd-colombia-orders.gd-colombia.workers.dev",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            nombre,
            telefono,
            items
          })
        }
      );

      const result = await response.json();

      console.log("Respuesta Worker:", result);

      if (response.ok) {

        alert("Pedido enviado correctamente.");

        // Vaciar carrito
        await fetch("/cart/clear.js", {
          method: "POST"
        });

        // Redirigir al inicio
        window.location.href = "/";

        return;
      }

      console.error(result);
      alert(result.error || "Ocurrió un error al enviar el pedido.");

    } catch (e) {

      console.error("ERROR:", e);
      alert("Error de conexión con el servidor.");

    } finally {

      button.disabled = false;
      button.innerText = "Solicitar pedido";

    }

  });

});